// src/components/ui/ConfirmModal.jsx
// Modal de confirmação genérico — substitui window.confirm e ConfirmModal inline duplicado.
import React from "react";

export default function ConfirmModal({
  titulo = "Confirmar",
  mensagem,
  onConfirm,
  onCancel,
  perigo = false,
  textoOk = "Confirmar",
  textoCancelar = "Cancelar",
  carregando = false,
}) {
  return (
    <div
      className="modal fade show d-block"
      style={{ background: "rgba(0,0,0,.5)" }}
      onClick={carregando ? undefined : onCancel}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="modal-dialog modal-dialog-centered"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {perigo && <i className="bi bi-exclamation-triangle text-danger me-2" />}
              {titulo}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onCancel}
              disabled={carregando}
              aria-label="Fechar"
            />
          </div>
          <div className="modal-body" style={{ fontSize: 14 }}>
            {mensagem}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onCancel}
              disabled={carregando}
            >
              {textoCancelar}
            </button>
            <button
              type="button"
              className={`btn ${perigo ? "btn-danger" : "btn-primary"}`}
              onClick={onConfirm}
              disabled={carregando}
            >
              {carregando ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" />
                  Aguarde...
                </>
              ) : (
                textoOk
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
